import { v4 as uuidv4 } from 'uuid';

/**
 * Next.js' routing doesn't re-render the component when doing a client-side
 * transition to the same page. Add a `key` query parameter so that props
 * change and we restart the session.
 */
type UrlInput = string | { pathname: string; query: Record<string, string | number> };

export const convertUrlToTriggerRefresh = (url: UrlInput | null): string => {
  if (url === null) {
    return '';
  }
  if (typeof url === 'string') {
    return url.includes('?') ? `${url}&key=${uuidv4()}` : `${url}?key=${uuidv4()}`;
  }

  const { pathname, query } = url;
  const queryString = Object.keys(query)
    .map(key => `${key}=${encodeURIComponent(query[key])}`)
    .join('&');

  return `${pathname}?${queryString}&key=${uuidv4()}`;
};
